export default __webpack_public_path__ + "static/media/total_carbono-atlas-new.13e8dba5.png";